export const OPERATOR_ROLES = ["CENTER", "BEC", "BED"];

const gid = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const number = Number(value);
  return Number.isSafeInteger(number) && number > 0 ? number : null;
};

export const normalizedOperatorRole = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const role = String(value).trim().toUpperCase();
  return ({ "1": "CENTER", "2": "BEC", "3": "BED" })[role] ||
    (OPERATOR_ROLES.includes(role) ? role : null);
};

// The request list projects the model's operatorRole as operatorType. Account
// records carry operatorRole directly. Only absent roles default to CENTER.
export const operatorTerritory = (row = {}) => {
  const rawRole = row.operatorRole ?? row.operatorType;
  // Only a missing role is a legacy CENTER operator. Unknown explicit values
  // remain invalid and visible as such.
  const role = rawRole === null || rawRole === undefined || String(rawRole).trim() === ""
    ? "CENTER"
    : (normalizedOperatorRole(rawRole) || "UNSPECIFIED");
  const votingCenterGid = gid(row.votingCenterGid);
  const communeGid = gid(row.communeGid);
  const departmentGid = gid(row.departmentGid);

  const territoryGid = ({ CENTER: votingCenterGid, BEC: communeGid, BED: departmentGid })[role] ?? null;
  const territoryLabel = row.territoryLabel || (territoryGid ? `#${territoryGid}` : "");
  const valid = territoryGid !== null && (
    role === "CENTER" ||
    ((role === "BEC" || role === "BED") && votingCenterGid === null)
  );

  return { role, votingCenterGid, communeGid, departmentGid,
    territoryGid, territoryLabel, valid };
};

export const operatorRoleLabelKey = (role) =>
  OPERATOR_ROLES.includes(role) ? `operator.type.${role}` : "operator.type.UNSPECIFIED";

export const operatorScopeLabelKey = (role) => ({
  CENTER: "operator.scope.CENTER",
  BEC: "operator.scope.BEC",
  BED: "operator.scope.BED"
})[role] || "operator.scope.unassigned";
